import type { PlayerAssignment, ValidationError, PuzzleRole } from '../../types/game';
import { useTranslation } from 'react-i18next';
import { PlayerCard } from './PlayerCard';

interface ZoneAPlayersProps {
  assignments: PlayerAssignment[];
  onSetRole: (seat: number, role: PuzzleRole) => void;
  errors: ValidationError[];
  focusedSeat: number | null;
  onFocus: (seat: number) => void;
  onBlur: () => void;
}

export function ZoneA_Players({
  assignments,
  onSetRole,
  errors,
  focusedSeat,
  onFocus,
  onBlur,
}: ZoneAPlayersProps) {
  const { t } = useTranslation('game');

  return (
    <div className="flex flex-col gap-3">
      <h3 className="font-mono text-xs tracking-widest uppercase text-mafia-muted">
        {t('board.zones.players')}
      </h3>
      <div className="grid grid-cols-2 gap-2 lg:grid-cols-1">
        {assignments.map((assignment) => (
          <PlayerCard
            key={assignment.seat}
            assignment={assignment}
            onSetRole={onSetRole}
            errors={errors}
            isFocused={focusedSeat === assignment.seat}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        ))}
      </div>
    </div>
  );
}
